import React from "react";
import { Theme } from "../../theme";

export const DownCarrat = ({ fill, ...props }) => {
    return (
        <svg
            width="15px"
            height="8px"
            viewBox="0 0 15 8"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
            >
                <g
                    transform="translate(-571.000000, -339.000000)"
                    stroke={fill || Theme.colors.blue}
                    strokeWidth="2"
                >
                    <g transform="translate(326.000000, 292.463440)">
                        <polyline
                            transform="translate(252.866043, 50.420161) rotate(90.000000) translate(-252.866043, -50.420161) "
                            points="250.220237 44.4445466 255.511849 50.4204626 250.220237 56.3957744"
                        ></polyline>
                    </g>
                </g>
            </g>
        </svg>
    );
};
